export default __webpack_public_path__ + "static/media/Version (4) - Half-Blood Prince_10.dac3d04d.jpg";